// js/config.js
// 全域設定。聯絡資訊請替換為你的真實內容。

export const CONFIG = {
  contact: {
    email: 'Hhservicehk@outlook.com',
    // WhatsApp：國際格式（+852 6638 6086 → 85266386086）
    whatsapp: '85266386086',
    // 額外連結（可選）；留空陣列即不顯示
    links: [
      // { label: 'GitHub', url: 'https://github.com/yourname' },
    ],
  },
};
